import * as Yup from 'yup';

const tagsSchema = Yup.object().shape({
  email: Yup.string().email(),
  // TODO add future tags validation
});

export default tagsSchema;
